import Vue from 'vue';
import App from './App.vue';

import Upload from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'

Vue.use(Upload)

import VueRouter from 'vue-router';
Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: () => App,
            meta: {
                keepAlive: true // 需要被缓存
            }
        },
        {
            path: '/index.html',
            component: () => App,
            meta: {
                keepAlive: true // 需要被缓存
            }
        },
        {
            path: '/home',
            component: () => import('./pages/home'),
            meta: {
                keepAlive: true // 不需要被缓存
            }
        },
        {
            path: '/report',
            component: () => import('./pages/report'),
            meta: {
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: '*',
            redirect: '/'
        }
    ]
});


import i18n from '@/lang';

import logger from '@/utils/logger';

Vue.prototype.$log = logger;

Vue.config.productionTip = false;

let padding = function(d) {
    return d >= 10 ? `${d}` : `0${d}`;
}
let monthes = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', ];

Vue.filter('formatDate', d => {
    return `${monthes[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
});
Vue.filter('formatTime', d => {
    return `${padding(d.getHours())}:${padding(d.getMinutes())}:${padding(d.getSeconds())}`;
});

Vue.filter('formatNum', d => {
    return (d || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
});

Vue.filter('formatPrice', d => {
    d = (d || 0).toFixed(2);
    let nums = d.split('.', 2);
    // return nums[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.' + nums[1];
    return nums[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
});

import message from 'ant-design-vue/lib/message';
message.config({
    duration: 1,
    maxCount: 1
});


new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app');
